/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button, DropDown, Input, ModalComp } from "../../components";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CreatePromotionalOffer,
  DeletePromotionalOffer,
  GetPromotionalOffersDetails,
  UpdatePromotionalOffer,
} from "../../utilities/api/promotionalOffer";
import {
  nameValidation2,
  nameWithNumberValidation,
} from "../../utilities/utils";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { toast } from "react-toastify";
import { messages } from "../../utilities/Messages";

const getMessage = messages.offers;

const CreateUpdatePromotionOffers = () => {
  const navigate = useNavigate();
  const location = useLocation().state;
  const { AllSportsData, sportErrorMessage } = useAppSelector((state) => state.sportList);
  const [errorMessage, setErrorMessage] = useState({
    offerSports: "",
    name: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    discountPercent: "",
  });
  if (sportErrorMessage) {
    toast.error(sportErrorMessage.message)
  }
  const currentDate = () => {
    let date = new Date();
    let d = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    let m =
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1;
    let y = date.getFullYear();
    return `${d}-${m}-${y}`;
  };
  const [data, setData] = useState({
    offerSports: [],
    name: "",
    startDate: currentDate(),
    endDate: "",
    startTime: "",
    endTime: "",
    discountPercent: "",
    sportName: [],
    status: "",
  });
  const [endTimeOption, setEndTimeOption] = useState<string[]>([]);
  const [archive, setArchive] = useState(false);
  const hours = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const minutes = ["00", "30"];
  const TimeArray = hours.flatMap((hour) =>
    minutes.map((minute) => `${hour}:${minute}`)
  );

  const ALL_SPORTS = AllSportsData.map((item: any) => ({
    value: item.name,
    labelKey: item.id,
  }));

  const GetDetail = async () => {
    const result = await GetPromotionalOffersDetails(location.id);
    if (result.statusCode === 200) {
      setData({
        name: result.data.name,
        startDate: result.data.startDate?.split("/").join("-"),
        endDate: result.data.endDate?.split("/").join("-"),
        startTime: result.data.startTime,
        endTime: result.data.endTime,
        discountPercent: result.data.discountPercent,
        offerSports: result.data.offerSports?.map((item: any) => item.sport.id),
        sportName: result.data.offerSports?.reduce(
          (acc: any, cur: any) => acc + `${cur.sport?.name}, `,
          ""
        ),
        status: result.data.isActive ? "Active" : "Inactive",
      });
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    if (location.for === "Update") GetDetail();
  }, []);

  useEffect(() => {
    setEndTimeOption(TimeArray.filter((item) => item > data.startTime));
  }, [data.startTime]);

  const handleStartTimeChange = (e: any) => {
    setData({ ...data, startTime: e.target.value });
  };

  const hanleSportChange = (value: any) => {
    setData({ ...data, offerSports: value.selectedKey });
  };

  const handleEndDateChange = (date: any) => {
    setData({ ...data, endDate: date.format("DD-MM-YYYY") });
  };

  const handleStartDateChange = (date: any) => {
    setData({ ...data, startDate: date.format("DD-MM-YYYY") });
  };

  const Validate = () => {
    if (
      data.name.length < 3 ||
      data.name.length > 30 ||
      nameValidation2(data?.name) == null ||
      Number(data.discountPercent) <= 0 ||
      Number(data.discountPercent) > 100 ||
      data.endDate.length !== 10 ||
      !data.endTime ||
      data.offerSports.length <= 0 ||
      data.startDate.length !== 10 ||
      !data.startTime ||
      nameWithNumberValidation(data?.discountPercent) == null
    ) {
      setErrorMessage({
        offerSports: data.offerSports.length <= 0 ? getMessage.offerSports_required : "",
        name:
          data.name.length < 3 || data.name.length > 30
            ? getMessage.name_min_max_length
            : nameValidation2(data?.name) == null
              ? getMessage.name_matches
              : "",
        startDate:
          data.startDate.length !== 10 ? getMessage.startDate_required : "",
        endDate: data.endDate.length !== 10 ? getMessage.endDate_required : "",
        startTime: !data.startTime ? getMessage.startTime_required : "",
        endTime: !data.endTime ? getMessage.endTime_required : "",
        discountPercent:
          Number(data.discountPercent) <= 0 ||
            Number(data.discountPercent) > 100
            ? getMessage.discountPercent_maxLength
            : nameWithNumberValidation(data?.discountPercent) == null
              ? getMessage.discountPercent_valueType
              : "",
      });
      return false;
    } else return true;
  };

  const handleSubmit = async () => {
    let payload = {
      name: data.name,
      startDate: data.startDate.split("-").reverse().join("-"),
      endDate: data.endDate.split("-").reverse().join("-"),
      startTime: data.startTime,
      endTime: data.endTime,
      discountPercent: Number(data.discountPercent),
      offerSports: data.offerSports,
    };
    if (Validate()) {
      if (location.for === "Create") {
        const createOffer = await CreatePromotionalOffer(payload);
        if (createOffer.status === 200) {
          navigate("/discount-offers");
        } else {
          toast.error(createOffer.response.data.message);
        }
      } else {
        let updatePayload = {
          endDate: data.endDate.split("-").reverse().join("-"),
          startTime: data.startTime,
          endTime: data.endTime,
          discountPercent: Number(data.discountPercent),
        };
        const updateOffer = await UpdatePromotionalOffer(
          location.id,
          updatePayload
        );
        if (updateOffer.status === 200) {
          navigate("/discount-offers");
        } else {
          toast.error(updateOffer.response.data.message);
        }
      }
    }
  };

  const handleDelete = async () => {
    const deleteOffer = await DeletePromotionalOffer(location.id);
    if (deleteOffer.status === 200) {
      navigate("/discount-offers");
    } else {
      toast.error(deleteOffer.response.data.message);
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="text-start mb-0">
                {location?.for} Discount Offers
              </Card.Title>
              {location?.for !== "Create" && (
                <Button
                  onClick={() => setArchive(true)}
                  type="button"
                  bname="Delete Offers"
                  name="delete-offers"
                  id="delete-offers"
                  className="btn btn-danger rounded-1 "
                ></Button>
              )}
            </div>
            <hr />
            <Row className="align-items-end">
              {location?.for === "Create" ? (
                <>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <label htmlFor="event-name" className="form-label">
                        Event Name <small className="text-danger">*</small>
                      </label>
                      <Input
                        value={data.name}
                        onChange={(e: any) =>
                          setData({ ...data, name: e.target.value })
                        }
                        type="text"
                        placeholder="Enter Event Name"
                        className="form-control"
                        name="event-name"
                        id="event-name"
                      />
                      <span className="error-msg">{errorMessage.name}</span>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <label htmlFor="promotional" className="form-label">
                        Select Sports <small className="text-danger">*</small>
                      </label>
                      <BootstrapSelect
                        className="form-select-custom form-control d-block"
                        selectStyle=""
                        actionBtnStyle="btn-outline-primary"
                        options={ALL_SPORTS}
                        isMultiSelect={true}
                        showTick={true}
                        showSearch={true}
                        showAction={true}
                        placeholder="Send to"
                        defaultOptions={data.offerSports}
                        onChange={hanleSportChange}
                      />
                      <span className="error-msg">
                        {errorMessage.offerSports}
                      </span>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <label htmlFor="offerstartdate" className="form-label">
                        Offer Start Date{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <DatePicker
                        containerClassName="custom-container"
                        format="DD-MM-YYYY"
                        render={<InputIcon className="form-control" />}
                        value={data.startDate}
                        onChange={handleStartDateChange}
                        minDate={new Date()}
                      />
                      <span className="error-msg">
                        {errorMessage.startDate}
                      </span>
                    </div>
                  </Col>
                </>
              ) : (
                <>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <div className="fw-semibold mb-3">
                        Event Name:{" "}
                        <span className="text-info">{data.name}</span>{" "}
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <div className="fw-semibold mb-3">
                        Sport Name:{" "}
                        <span className="text-info">{data.sportName}</span>{" "}
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <div className="fw-semibold mb-3">
                        Offer Status:{" "}
                        <span className="text-info">{data.status}</span>{" "}
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <div className="fw-semibold mb-3">
                        Offer Start Date:{" "}
                        <span className="text-info">{data.startDate}</span>{" "}
                      </div>
                    </div>
                  </Col>
                </>
              )}
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="offerend-date" className="form-label">
                    Offer End Date <small className="text-danger">*</small>
                  </label>
                  <DatePicker
                    containerClassName="custom-container"
                    format="DD-MM-YYYY"
                    render={<InputIcon className="form-control" />}
                    value={data.endDate}
                    onChange={handleEndDateChange}
                    minDate={
                      new Date(data.startDate?.split("-").reverse().join("-"))
                    }
                  />
                  <span className="error-msg">{errorMessage.endDate}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="start-time" className="form-label">
                    Offer Start Time <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    id="start-time"
                    name="startTime"
                    className="form-control"
                    value={data.startTime}
                    onChange={handleStartTimeChange}
                  >
                    <option hidden disabled value="">
                      Select Start Time
                    </option>
                    {TimeArray.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </DropDown>
                  <span className="error-msg">{errorMessage.startTime}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="end-time" className="form-label">
                    Offer End Time <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    disabled={!data.startTime}
                    id="end-time"
                    name="endTime"
                    className="form-control"
                    value={data.endTime}
                    onChange={(e: any) =>
                      setData({ ...data, endTime: e.target.value })
                    }
                  >
                    <option hidden disabled value="">
                      Select End Time
                    </option>
                    {endTimeOption.map((elem) => (
                      <option key={elem} value={elem}>
                        {elem}
                      </option>
                    ))}
                  </DropDown>
                  <span className="error-msg">{errorMessage.endTime}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="pdiscount" className="form-label">
                    Discount % per Slot <small className="text-danger">*</small>
                  </label>
                  <Input
                    value={data.discountPercent}
                    onChange={(e: any) => {
                      const val = e.target.value;
                      if (val > -1 && val <= 100 && /^\d*\.?\d{0,2}$/.test(val)) {
                        setData({ ...data, discountPercent: val });
                      }
                    }}
                    type="number"
                    onKeyDown={(e: any) =>
                      ["e", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    placeholder="Enter Discount"
                    className="form-control"
                    name="pdiscount"
                    id="pdiscount"
                  />
                  <span className="error-msg">
                    {errorMessage.discountPercent}
                  </span>
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col lg={12} className="text-end">
                <Button
                  type="button"
                  bname={
                    location?.for === "Create" ? "Apply Offer" : "Change Offer"
                  }
                  name="apply-offer"
                  id="apply-offer"
                  className="btn btn-primary rounded-1"
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <ModalComp
        archive={archive}
        setArchive={setArchive}
        handleDelete={handleDelete}
      />
    </>
  );
};
export { CreateUpdatePromotionOffers };
